module.exports = __webpack_public_path__ + "static/media/view-active-speaker.bf293356.svg";